export enum EymemoriesProductTypes {
  DOWNLOAD_LINK = "DOWNLOAD_LINK",
  FREE_DOWNLOAD = "FREE_DOWNLOAD"
}

export enum EymemoriesStageSteps {
  VIEWED = "VIEWED",
  DOWNLOADED = "DOWNLOADED"
}

export type OrderDetails = {
  productType: EymemoriesProductTypes;
  meta: {
    downloadLink: string;
  };
};
